import { Size } from '@adornis/buildify/client/globals/enums.js';
import type { BuildifyExtension } from '@adornis/buildify/client/globals/types.js';
import { DubniumBaseContainerFlexWithLine } from 'db/buildify/container/DubniumBaseContainerFlexWithLine';
import { BuildifyCampusContainerFlexExtension } from './BuildifyCampusContainerFlexExtension.js';

export const BuildifyCampusContainerFlexLineExtension: BuildifyExtension<DubniumBaseContainerFlexWithLine> = {
  class: DubniumBaseContainerFlexWithLine,
  toolbar: { icon: 'diagram-cells', text: { default: 'Flex mit Linie' } },
  defaultValues: {
    hasLineLeft: { global: true },
    padding: {
      [Size.DESKTOP]: '0 0 0 32px',
      [Size.TABLET]: '0 0 0 24px',
      [Size.MOBILE]: '0 0 0 20px',
    },
    lineLeftWidth: { global: '3px' },
    lineLeftColor: { global: '#afca0b' },
  },
  render(instance, { isSubelement, dropzoneBefore, dropzoneAfter }) {
    return BuildifyCampusContainerFlexExtension(this.defaultValues).render(instance, {
      defaultValues: this.defaultValues,
      isSubelement,
      dropzoneBefore,
      dropzoneAfter,
    });
  },
  editor(options) {
    return BuildifyCampusContainerFlexExtension(this.defaultValues).editor!(options);
  },
  group: 'Layout',
};
